module.exports = __webpack_public_path__ + "img/39.c2207b0a.png";